"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.ttsFields = exports.isSkipped = exports.initialValues = exports.icon = exports.hasFeedback = exports.getMetricsPrefix = exports.getMetrics = exports.getDataDefinitions = exports.getDataConnectorsValues = exports.getDataConnectors = exports.fields = void 0;
var _react = _interopRequireDefault(require("react"));
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _isInt = _interopRequireDefault(require("validator/lib/isInt"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _optionTypes = _interopRequireDefault(require("./optionTypes"));
var _settings = require("../Player/settings.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var fields = exports.fields = function () {
  var result = [];

  // Option types
  (0, _forEach2["default"])(_optionTypes["default"], function (optionType, name) {
    optionType.fields.forEach(function (field) {
      result.push("optionTypes.".concat(name, "[].").concat(field));
    });
  });
  return ['question', 'description', 'visualType', 'singleOrMultiple', 'imageSize', 'imagePadding', 'verticalOrHorizontal', 'verticalWidth', 'singleAnswerRequired', 'multiAnswerMin', 'multiAnswerMax', 'missingReportValue', 'dropdownZeroLabel', 'dropdownWidth', 'maxWidth', 'minButtonHeight', 'buttonTextAlign', 'showLabelsInMatrixHeader', 'requiredErrorMessage', 'minAnswersErrorMessage', 'maxAnswersErrorMessage', 'options[].id', 'options[].code', 'options[].type', 'options[].label', 'options[].isExpanded', 'isOptionsExpanded', 'isRadioDropdownExpanded', 'isSettingsExpanded', 'isRequiredExpanded', 'isValidationExpanded', 'hasCorrectAnswers', 'showCorrectnessFeedback', 'correctAnswers', 'showAnswerFeedbackExpanded', 'showAnswerFeedback', 'answerFeedbackForOptions', 'answerFeedbackPositive', 'answerFeedbackNegative'].concat(result);
}();
var ttsFields = exports.ttsFields = function ttsFields(_ref) {
  var settings = _ref.settings,
    isMatrixMode = _ref.isMatrixMode;
  var result = isMatrixMode ? [] : ['question', 'description'];
  result.push.apply(result, _toConsumableArray(settings.options.map(function (item, index) {
    return "options[".concat(index, "].label");
  })));
  return result;
};
var initialValues = exports.initialValues = {
  question: '<p><strong>What is your opinion about ...?</strong></p>',
  visualType: 'radio',
  labelPosition: 'top',
  singleOrMultiple: 'single',
  imageSize: 'medium',
  imagePadding: false,
  verticalOrHorizontal: 'vertical',
  verticalWidth: 'large',
  dropdownZeroLabel: '-- Choose an option --',
  dropdownWidth: 'auto',
  maxWidth: '300px',
  buttonTextAlign: 'center',
  requiredErrorMessage: 'An answer is required.',
  minAnswersErrorMessage: 'Choose :min or more items',
  maxAnswersErrorMessage: 'Choose :max or fewer items',
  options: [{
    id: 1,
    label: 'Choice',
    type: 'static'
  }, {
    id: 2,
    label: 'Choice',
    type: 'static'
  }, {
    id: 3,
    label: 'Choice',
    type: 'static'
  }],
  optionTypes: {
    "static": [{
      id: 1,
      userTextPlaceholder: '(Please specify)'
    }, {
      id: 2,
      userTextPlaceholder: '(Please specify)'
    }, {
      id: 3,
      userTextPlaceholder: '(Please specify)'
    }]
  },
  isOptionsExpanded: true,
  isRadioDropdownExpanded: true,
  hasCorrectAnswers: false,
  showCorrectnessFeedback: false
};
var icon = exports.icon = /*#__PURE__*/_react["default"].createElement("i", {
  className: "glyphicon glyphicon-option-vertical"
});
var validate = exports.validate = function validate(values) {
  var errors = {};
  var options = values.options,
    singleOrMultiple = values.singleOrMultiple,
    multiAnswerMin = values.multiAnswerMin,
    multiAnswerMax = values.multiAnswerMax,
    visualType = values.visualType,
    renderInColumns = values.renderInColumns,
    verticalOrHorizontal = values.verticalOrHorizontal,
    hasCorrectAnswers = values.hasCorrectAnswers,
    correctAnswers = values.correctAnswers;
  (0, _forEach2["default"])(_optionTypes["default"], function (element, type) {
    var elementErrors = (0, _cccisdSurveyCommon.validateElement)(values.optionTypes[type] || [], element.validate);
    if (elementErrors.length === 0) {
      return;
    }
    errors = _objectSpread(_objectSpread({}, errors), {}, {
      optionTypes: _objectSpread(_objectSpread({}, errors.optionTypes), {}, _defineProperty({}, type, elementErrors))
    });
  });
  if (visualType === 'checkbox' || visualType === 'image' && singleOrMultiple === 'multiple' || visualType === 'button' && singleOrMultiple === 'multiple') {
    if (multiAnswerMin && !(0, _isInt["default"])(multiAnswerMin.toString(), {
      min: 1,
      max: options.length
    })) {
      errors.multiAnswerMin = "Value should be a number between 1 and ".concat(options.length);
    }
    if (multiAnswerMax && !(0, _isInt["default"])(multiAnswerMax.toString(), {
      min: 1,
      max: options.length
    })) {
      errors.multiAnswerMax = "Value should be a number between 1 and ".concat(options.length);
    }
    if (multiAnswerMin && multiAnswerMax && !errors.multiAnswerMin && !errors.multiAnswerMax) {
      if (+multiAnswerMin > +multiAnswerMax) {
        errors.multiAnswerMax = 'Max should be more than min';
      }
    }
  }
  if ((visualType === 'radio' || visualType === 'checkbox') && verticalOrHorizontal === 'horizontal') {
    if (renderInColumns && !(0, _isInt["default"])(renderInColumns.toString(), {
      min: 2,
      max: 10
    })) {
      errors.renderInColumns = 'Value should be a whole number 2 to 10';
    }
  }
  if (hasCorrectAnswers) {
    if (!correctAnswers || correctAnswers.length === 0) {
      errors.correctAnswers = 'Choose at least one correct answers';
    }
  }
  return errors;
};
var getMetricsPrefix = exports.getMetricsPrefix = function getMetricsPrefix() {
  return 'mc';
};
var getDataDefinitions = exports.getDataDefinitions = function getDataDefinitions(id, settings) {
  var isMatrix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var metricsPrefix = getMetricsPrefix();
  var question = settings.question,
    visualType = settings.visualType,
    singleOrMultiple = settings.singleOrMultiple,
    options = settings.options,
    hasCorrectAnswers = settings.hasCorrectAnswers;
  var staticTypes = (0, _get2["default"])(settings, 'optionTypes.static', []);
  var hasLists = options.some(function (option) {
    return option.type === 'list';
  });
  if (hasLists) {
    var defintion = {
      type: 'text',
      variableType: 'answer',
      questionType: 'dynamicMultipleChoice',
      tags: {
        system: ['answer']
      },
      title: (0, _cccisdSurveyCommon.stripTags)(question),
      titleHtml: question
    };
    return _defineProperty(_defineProperty({}, id + '_answer_id', _objectSpread(_objectSpread({}, defintion), {}, {
      reportHeader: "".concat(metricsPrefix, "_").concat(id, "_id")
    })), id + '_answer_label', _objectSpread(_objectSpread({}, defintion), {}, {
      reportHeader: "".concat(metricsPrefix, "_").concat(id, "_label")
    }));
  }
  var isSingle = visualType === 'radio' || visualType === 'dropdown' || visualType === 'image' && singleOrMultiple === 'single' || visualType === 'button' && singleOrMultiple === 'single';
  if (isSingle) {
    var _data = _defineProperty({}, id + '_answer', {
      "enum": options.map(function (option) {
        return option.id;
      }),
      enumDisplayText: options.map(function (option) {
        return (0, _cccisdSurveyCommon.stripTags)(option.label);
      }),
      enumDisplayTextHtml: options.map(function (option) {
        return option.label;
      }),
      questionType: 'MC - select one',
      variableType: 'answer',
      reportHeader: "".concat(metricsPrefix, "_").concat(id),
      tags: {
        system: ['answer']
      }
    });
    if (!isMatrix) {
      _data[id + '_answer'].title = (0, _cccisdSurveyCommon.stripTags)(question);
      _data[id + '_answer'].titleHtml = question;
    } else {
      _data[id + '_answer'].subtitle2 = (0, _cccisdSurveyCommon.stripTags)(question);
      _data[id + '_answer'].subtitle2Html = question;
    }
    if (hasCorrectAnswers) {
      _data[id + '_correct_answer'] = _objectSpread(_objectSpread({}, (0, _pick2["default"])(_data[id + '_answer'], ['title', 'titleHtml', 'subtitle2', 'subtitle2Html', 'tags', 'questionType'])), {}, {
        variableType: 'correct',
        reportHeader: "".concat(metricsPrefix, "_").concat(id, "_correct"),
        "enum": [0, 1],
        enumDisplayText: ['incorrect', 'correct']
      });
    }
    options.filter(function (option) {
      return option.type === 'static';
    }).forEach(function (option) {
      var optionType = staticTypes.find(function (item) {
        return item.id === option.id;
      }) || {};
      if (optionType.allowUserText) {
        _data[id + '_user_text_' + option.id] = _objectSpread(_objectSpread({}, (0, _pick2["default"])(_data[id + '_answer'], ['questionType', 'tags', 'title', 'titleHtml', 'subtitle1', 'subtitle1Html', 'subtitle2', 'subtitle2Html'])), {}, {
          type: 'text',
          variableType: 'qualitative',
          reportHeader: "".concat(metricsPrefix, "_").concat(id, "_user_text_").concat(option.id)
        }, !isMatrix ? {
          subtitle1: (0, _cccisdSurveyCommon.stripTags)(option.label),
          subtitle1Html: option.label
        } : {
          subtitle3: (0, _cccisdSurveyCommon.stripTags)(option.label),
          subtitle3Html: option.label
        });
      }
    });
    return _data;
  }
  var data = {};
  var prefix = id + '_answer_';
  var questionType = 'MC - select multiple';
  (0, _forEach2["default"])(options, function (option) {
    data[prefix + option.id] = {
      "enum": [0, 1],
      enumDisplayText: ['unchecked', 'checked'],
      questionType: questionType,
      tags: {
        system: ['answer']
      },
      reportHeader: "".concat(metricsPrefix, "_").concat(id, "_").concat(option.id),
      variableType: 'answer'
    };
    if (!isMatrix) {
      data[prefix + option.id].title = (0, _cccisdSurveyCommon.stripTags)(question);
      data[prefix + option.id].titleHtml = question;
      data[prefix + option.id].subtitle1 = (0, _cccisdSurveyCommon.stripTags)(option.label);
      data[prefix + option.id].subtitle1Html = option.label;
    } else {
      data[prefix + option.id].subtitle2 = (0, _cccisdSurveyCommon.stripTags)(question);
      data[prefix + option.id].subtitle2Html = question;
      data[prefix + option.id].subtitle3 = (0, _cccisdSurveyCommon.stripTags)(option.label);
      data[prefix + option.id].subtitle3Html = option.label;
    }
    if (option.type === 'static') {
      var optionType = staticTypes.find(function (item) {
        return item.id === option.id;
      }) || {};
      if (optionType.allowUserText) {
        data[id + '_user_text_' + option.id] = _objectSpread(_objectSpread({}, (0, _pick2["default"])(data[prefix + option.id], ['questionType', 'tags', 'title', 'titleHtml', 'subtitle1', 'subtitle1Html', 'subtitle2', 'subtitle2Html', 'subtitle3', 'subtitle3Html'])), {}, {
          variableType: 'qualitative',
          type: 'text',
          reportHeader: "".concat(metricsPrefix, "_").concat(id, "_user_text_").concat(option.id)
        });
      }
    }
  });
  if (hasCorrectAnswers) {
    data[id + '_correct_answer'] = _objectSpread(_objectSpread({}, isMatrix ? {
      subtitle2: (0, _cccisdSurveyCommon.stripTags)(question),
      subtitle2Html: question
    } : {
      title: (0, _cccisdSurveyCommon.stripTags)(question),
      titleHtml: question
    }), {}, {
      "enum": [0, 1],
      enumDisplayText: ['incorrect', 'correct'],
      questionType: questionType,
      reportHeader: "".concat(metricsPrefix, "_").concat(id, "_correct"),
      tags: {
        system: ['answer']
      },
      variableType: 'correct'
    });
  }
  return data;
};
var getMetrics = exports.getMetrics = function getMetrics(id, settings, answer) {
  if (answer) {
    answer = (0, _settings.processValue)(answer);

    // if a user interacts with a radio and then de-selects it sets metrics to null
    if (!answer.selected.length) {
      answer = null;
    }
  }
  var visualType = settings.visualType,
    singleOrMultiple = settings.singleOrMultiple,
    options = settings.options,
    hasCorrectAnswers = settings.hasCorrectAnswers,
    correctAnswers = settings.correctAnswers;
  var staticTypes = (0, _get2["default"])(settings, 'optionTypes.static', []);
  var hasLists = options.some(function (option) {
    return option.type === 'list';
  });
  var staticIds = options.filter(function (option) {
    return option.type === 'static';
  }).map(function (option) {
    return option.id;
  });
  var userTextMetrics = staticTypes.filter(function (type) {
    return type.allowUserText && staticIds.includes(type.id);
  }).reduce(function (result, optionType) {
    result[id + '_user_text_' + optionType.id] = answer && typeof answer.userTexts[optionType.id] === 'string' ? answer.userTexts[optionType.id] : null;
    return result;
  }, {});
  var isSingle = visualType === 'radio' || visualType === 'dropdown' || visualType === 'image' && singleOrMultiple === 'single' || visualType === 'button' && singleOrMultiple === 'single';
  if (isSingle) {
    var _correctMetrics = hasCorrectAnswers ? _defineProperty({}, id + '_correct_answer', null) : {};
    if (hasCorrectAnswers && answer && answer.selected && answer.selected.length > 0) {
      _correctMetrics[id + '_correct_answer'] = correctAnswers.includes(answer.selected[0]) ? 1 : 0;
    }
    if (!answer) {
      return hasLists ? _objectSpread(_objectSpread(_defineProperty(_defineProperty({}, id + '_answer_id', null), id + '_answer_label', null), userTextMetrics), _correctMetrics) : _objectSpread(_objectSpread(_defineProperty({}, id + '_answer', null), userTextMetrics), _correctMetrics);
    }
    return hasLists ? _objectSpread(_defineProperty(_defineProperty({}, id + '_answer_id', answer.selected[0].toString()), id + '_answer_label', answer.selectedLabels[answer.selected[0]]), _correctMetrics) : _objectSpread(_objectSpread(_defineProperty({}, id + '_answer', answer.selected[0]), userTextMetrics), _correctMetrics);
  }
  var correctMetrics = {};
  if (hasCorrectAnswers) {
    var _answer;
    // Must have every option correct to get the whole question correct
    var selectedOptions = Array.isArray((_answer = answer) === null || _answer === void 0 ? void 0 : _answer.selected) ? answer.selected : [];
    correctMetrics[id + '_correct_answer'] = options.every(function (opt) {
      return correctAnswers.includes(opt.id) === selectedOptions.includes(opt.id);
    }) ? 1 : 0;
  }
  if (hasLists) {
    if (!answer) {
      return _objectSpread(_defineProperty(_defineProperty({}, id + '_answer_id', null), id + '_answer_label', null), correctMetrics);
    }
    return _objectSpread(_defineProperty(_defineProperty({}, id + '_answer_id', JSON.stringify(answer.selected)), id + '_answer_label', JSON.stringify(answer.selected.map(function (item) {
      return answer.selectedLabels[item];
    }))), correctMetrics);
  }
  var result = _objectSpread(_objectSpread({}, userTextMetrics), correctMetrics);
  var prefix = id + '_answer_';
  (0, _forEach2["default"])(options, function (option) {
    if (!answer) {
      result[prefix + option.id] = null;
    } else {
      result[prefix + option.id] = answer.selected.includes(option.id) ? 1 : 0;
    }
  });
  return result;
};
var getDataConnectors = exports.getDataConnectors = function getDataConnectors(settings) {
  var hasLists = settings.options.some(function (option) {
    return option.type === 'list';
  });
  if (hasLists) {
    return {};
  }
  return {
    commaText: {
      type: 'string',
      title: 'Comma separated selected options'
    },
    listText: {
      type: 'string',
      title: 'Selected options as a list'
    },
    selectedArray: {
      deprecated: true,
      type: 'array',
      title: 'Selected codes',
      meta: {
        possibleValues: settings.options.filter(function (option) {
          return option.code;
        }).map(function (option) {
          return {
            value: option.code,
            label: (0, _cccisdSurveyCommon.shortenText)({
              text: (0, _cccisdSurveyCommon.stripTags)(option.label),
              length: 18
            })
          };
        })
      }
    },
    selectedCollection: {
      type: 'collection',
      title: 'Selected options'
    },
    selectedIds: {
      type: 'array',
      title: 'Selected options',
      meta: {
        possibleValues: settings.options.map(function (option) {
          return {
            value: option.id,
            label: (0, _cccisdSurveyCommon.shortenText)({
              text: (0, _cccisdSurveyCommon.stripTags)(option.label),
              length: 18
            })
          };
        })
      }
    }
  };
};
var getDataConnectorsValues = exports.getDataConnectorsValues = function getDataConnectorsValues(settings, answer) {
  var language = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en';
  var hasLists = settings.options.some(function (option) {
    return option.type === 'list';
  });
  if (hasLists) {
    return {};
  }
  if (answer) {
    answer = (0, _settings.processValue)(answer);
  }
  return {
    commaText: function commaText() {
      if (!answer) {
        return answer;
      }
      var selected = settings.options.filter(function (option) {
        return answer.selected.includes(option.id);
      }).map(function (option) {
        var _answer2;
        return ((_answer2 = answer) === null || _answer2 === void 0 ? void 0 : _answer2.userTexts[option.id]) || (0, _cccisdWysiwyg.toHtml)(option.label);
      });
      if (selected.length <= 2) {
        return selected.join(language === 'es' ? ' y ' : ' and ');
      }
      return selected.slice(0, -1).join(', ') + (language === 'es' ? ' y ' : ', and ') + selected.slice(-1);
    },
    listText: function listText() {
      if (!answer) {
        return answer;
      }
      var list = settings.options.filter(function (option) {
        return answer.selected.includes(option.id);
      }).map(function (option) {
        var _answer3;
        var value = ((_answer3 = answer) === null || _answer3 === void 0 ? void 0 : _answer3.userTexts[option.id]) || (0, _cccisdWysiwyg.toHtml)(option.label);
        return "<li>".concat(value, "</li>");
      }).join('');
      return "<ul>".concat(list, "</ul>");
    },
    selectedArray: function selectedArray() {
      if (!answer) {
        return [];
      }
      return answer.selected.map(function (choiceId) {
        return (0, _find2["default"])(settings.options, {
          id: choiceId
        }).code;
      });
    },
    selectedCollection: function selectedCollection() {
      if (!answer) {
        return [];
      }
      return answer.selected.map(function (choiceId) {
        var option = (0, _find2["default"])(settings.options, {
          id: choiceId
        });
        return {
          id: choiceId,
          code: option.code,
          name: (0, _cccisdWysiwyg.toHtml)(option.label)
        };
      });
    },
    selectedIds: function selectedIds() {
      return answer ? answer.selected : [];
    }
  };
};
var hasFeedback = exports.hasFeedback = function hasFeedback(_ref4) {
  var settings = _ref4.settings,
    answer = _ref4.answer;
  if (answer && answer.selected && answer.selected.length > 0) {
    return true;
  }
  return false;
};
var isSkipped = exports.isSkipped = function isSkipped(_ref5) {
  var settings = _ref5.settings,
    answer = _ref5.answer;
  if (!answer) {
    return true;
  }
  if (!answer.selected || answer.selected.length === 0) {
    return true;
  }
  return false;
};